export default `
/* CSS Example
  body {
    background-color: #f0f0f0;
  }
  h1 {
    color: #002c38;
  }
 */
`;
